<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="false"
  >
      <template #layoutContent>
        <div class="row m-10">
          <NpsForm :default-form="defaultForm" :submit-form="storeNewNps" :loading="loading" :title="$t('nps.new')"/>
        </div>
      </template>
  </SubLayout>
</template>

<script setup>
import {onMounted, ref} from "vue";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import {useStore} from "vuex";
import NpsForm from "../../components/NpsForm.vue";
import { useRouter } from "vue-router";
import { computed } from "vue";

const store = useStore()
const router = useRouter()

const title = ref("breadcrumbs.nps")
const breadcrumbs = ref([
{
  name: 'breadcrumbs.questions',
  route: 'nps'
}
])
const company = computed(() => store.getters['offices/getSelectedCompany'])

const loading = ref(false)
const defaultForm = ref({
  title:"",
  name:"",
  nps_description:"",
  icon:"",
  society_id:"",
  min_value: 1,
  max_value:10,
  fields: []
}) 


function storeNewNps({data, submit}){
  loading.value = true
  store.dispatch('nps/createNps', {...data, society_id: company?.value.id, name: data?.title})
      .then(res => {
        window.toastr['success'](i18n.global.t("notification.nps_created"))
        if(submit){
          router.push({name:"nps-details", params: {id: res.data.data.id}})
        }
      })
      .catch((err) => {
      })
      .finally(() => loading.value = false)
}

const loadFieldTypes = () => {
  store.dispatch('nps/getFieldTypes')
}

onMounted(() => {
  loadFieldTypes()
})

</script>

<style scoped>
.password-input {
  position: relative;
}

.toggle-password {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

#eye-icon {
  font-size: 1.2em;
}
</style>
